import { gql } from 'graphql-request';
import {
  AccreditationInfoFragment,
  BankAccountFragment,
  EntityPropertiesFragment,
  InvestmentClassFragment,
  InvestmentClassFragmentFund,
  InvestmentFragment,
  LayoutFragment,
  LocationFragment,
  TaxInfoFragment,
  UpdatesFragment,
  UserPreferenceFragment,
  UserSettingsFragment,
} from '../fragments/fragments';

export const GET_USER_INVESTOR = gql`
  ${UserSettingsFragment}
  ${UpdatesFragment}
  ${LocationFragment}
  ${EntityPropertiesFragment}
  ${LayoutFragment}
  ${TaxInfoFragment}
  ${AccreditationInfoFragment}
  ${BankAccountFragment}
  ${UserPreferenceFragment}
  ${InvestmentFragment}
  ${InvestmentClassFragment}
  ${InvestmentClassFragmentFund}

  query GetUserInvestor {
    findCurrentUser {
      id
      firstName
      lastName
      language
      email
      role
      settings {
        ...UserSettingsFragment
      }
      userLegalEntities {
        id
        name
        investorIDs
        deceased
        viewerIDs
        operatorId
        uniqueId
        managerIDs
        approvedTaxInfo {
          ...TaxInfoFragment
        }
        pendingTaxInfo {
          ...TaxInfoFragment
        }
        approvedAccreditationInfo {
          ...AccreditationInfoFragment
        }
        pendingAccreditationInfo {
          ...AccreditationInfoFragment
        }
        approvedBankAccounts {
          ...BankAccountFragment
        }
        pendingBankAccounts {
          ...BankAccountFragment
        }
        userPreferences {
          ...UserPreferenceFragment
        }
        suggestedUserPreferences {
          ...UserPreferenceFragment
        }
        userPreferenceCustomQuestions {
          id
          question
          answers {
            description
            key
          }
        }
      }

      investmentDetails {
        ...InvestmentFragment
        legalEntityId
        amount
        email
        percentage
        period
        exitDate
        isContribution
        type
        id
        date
        investedBy
        commitment
        netRoi
        grossRoi
        netIrr
        grossIrr
        netCoc
        grossCoc
        customizedStatistics {
          key
          value
        }
        ref {
          key
          value
        }

        holdings {
          date
          value
        }
        manualHoldings {
          date
          value
        }
        operatorDetails {
          id
          name
          isUnderMaintenance
          description {
            en
            heb
          }
          websiteUrl
          layout {
            ...LayoutFragment
          }
          contacts {
            fax
            main
            name
            phone
            mobile
            email
          }
          updatesDetails {
            ...UpdatesFragment
          }
          offerDetails {
            category
            customCategory
            description {
              en
              heb
            }
            id
            location {
              ...LocationFragment
            }
            name
            operatorId
          }

          overviewKpisCategories
        }
        projectDetails {
          id
          category
          customCategory
          currency
          calculationType
          inceptionDate
          closingDate
          operatorId
          description {
            en
            heb
          }
          status
          kpis
          ...InvestmentClassFragment
          layout {
            ...LayoutFragment
          }
          portfolio {
            key
            value
          }
          location {
            ...LocationFragment
          }
          updatesDetails {
            ...UpdatesFragment
          }
          name
          properties {
            ...EntityPropertiesFragment
          }
        }
        fundDetails {
          description {
            en
            heb
          }
          id
          name
          inceptionDate
          operatorId
          status
          currency
          ...InvestmentClassFragmentFund
          layout {
            ...LayoutFragment
          }
          portfolio {
            key
            value
            group
          }
          projectDetails {
            category
            customCategory
            description {
              en
              heb
            }
            name
            portfolio {
              key
              value
            }
            fundId
            operatorId
            id
            location {
              ...LocationFragment
            }
          }
          updatesDetails {
            ...UpdatesFragment
          }
          properties {
            ...EntityPropertiesFragment
          }
        }
      }
    }
  }
`;
